import { Step } from '../../types/tour';

export const sidebar: Step[] = [
  { id: 1, label: 'Introduction', completed: false },
  { id: 2, label: 'Setup Client', completed: false },
  { id: 3, label: 'Create Call', completed: false },
  { id: 4, label: 'Join Call', completed: false },
  { id: 5, label: 'Customize Call', completed: false },
  { id: 6, label: 'Observe the Call State', completed: false },
  { id: 7, label: 'Exploring other use-cases', completed: false },
  { id: 8, label: 'Conclusion', completed: false },
];
